const generateForm07 = [
  {
    label: "เหตุผลในการลาออก", // i18n-ignore (translated at render site)
    name: "reason_quit",
    placeholder: "",
    type: "textarea",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
];

export default generateForm07;
